module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-8-11805fcc384bca621a71cc08bdee351a.jpg";